import { render, staticRenderFns } from "./client-notes.vue?vue&type=template&id=665faedd"
import script from "./client-notes.vue?vue&type=script&lang=js"
export * from "./client-notes.vue?vue&type=script&lang=js"
import style0 from "./client-notes.vue?vue&type=style&index=0&id=665faedd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports